import React from 'react';
import './App.css';
import {  Switch,Route } from 'react-router-dom'
import Home from "./components/Home";
import Status from "./components/Status"
import ReactGA from 'react-ga4'

class App extends React.Component {
  componentDidMount() {
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    try {
      ReactGA.initialize('G-W4S0WZF5SD');
      ReactGA.send({
        hitType: 'pageview',
        page: `${window.location.pathname}${window.location.search}`
      });
    } catch (error) {
      // Ignore analytics failures so extension/network issues never crash UI rendering.
    }
  }

  render(){
    return (
      <div className="app-shell">
        <main className="route-shell">
          <Switch>
            <Route exact path="/" component = {Home}/>
            <Route path="/status+goal+current projects+university_life" component={Status}/>
          </Switch>
        </main>
      </div>
    );
  }
}

export default App;
